var _rect, _path, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 7.5,
    fill: "#DFE6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2502 21.5C17.0547 21.465 15.8483 20.9281 14.7288 20.2745C12.2072 18.8272 10.3487 16.6445 9.03357 13.96C8.14233 12.1276 8.39231 10.3651 9.59874 9.01118C9.99002 8.57933 10.9465 8.34589 11.4356 8.61434C11.5877 8.69605 11.729 8.89447 11.8051 9.08121C12.1638 9.9566 12.5116 10.8437 12.8268 11.7307C12.892 11.9175 12.8594 12.1859 12.805 12.3843C12.7507 12.5828 12.6202 12.7578 12.5007 12.9212C11.729 13.9834 11.7399 13.9717 12.479 15.0688C13.4354 16.4928 14.6744 17.5199 16.1743 18.1969C16.5873 18.3836 16.8373 18.3019 17.0873 17.9401C17.3264 17.5899 17.6199 17.2631 17.8481 16.9013C18.0655 16.5512 18.3155 16.4461 18.6633 16.6212C19.5219 17.053 20.3805 17.4732 21.2174 17.9518C21.3804 18.0451 21.5 18.3836 21.5 18.6171C21.5 20.3678 20.2284 21.2082 18.9024 21.4533C18.7285 21.4883 18.5437 21.4767 18.2394 21.4883L18.2502 21.5Z",
    fill: "#070A0E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 7.5,
    stroke: "#DFE6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallBtn);
export default __webpack_public_path__ + "static/media/callBtn.f858f1d4e4f7cf41c13fedc4d01b0e43.svg";
export { ForwardRef as ReactComponent };